// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"902dcd8f","455":"03e51375","977":"0e015c20"}[chunkId] + ".chunk.js";
};